<template>
    <div class="row justify-content-center user-profile ccbs">
        <div class="col-12 pb-5 text-center">
            <img src="/static/assets/images/ico-assinatura-ccb.svg" class="mb-4 icon-assinatura" alt="icone assinatura">
            <h1>Visualize e assine!</h1>
            <p>Veja e assine as CCB's relativas a solicitação de empréstimo de sua empresa.</p>
        </div>
        <div class="col-12 col-md-8">
            <h2>Lista de CCB’s</h2>
            <div class="table-responsive">
                <table class="table table-hover">
                    <tbody>
                        <tr  v-for="(pag, index) in reservas" v-bind:key="pag._id">
                            <th scope="row" class="align-middle">{{index+1}}</th>
                            <td class="align-middle">
                                <span class="d-flex align-items-center">
                                    <img src="/static/assets/images/ico-pdf.png" alt="icone ccb">
                                    <small>{{pag.CodigoBMP}}</small>
                                </span>
                            </td>
                            <td class="align-middle"><a :href='CCB_URL+"/imprimirccb.aspx?code="+pag.CodigoBMP+"&copias=1"' class="btn btn-sm btn-link" target="_blank" title="Visualizar CCB">Visualizar</a></td>
                        </tr>
                        
                      
                    </tbody>
                </table>
            </div>

        </div>
        <aside class="col-12 col-md-4 text-center">
            <div class="box p-3 p-md-4">
                <form v-if="passo == 1">
                    <h5 class="text">Para assinar todas as CCB's clique no botão abaixo.</h5>
                    <span class="text">Por favor insira o token que foi enviado para o seu email para finalizar as assinaturas de suas CCB's.</span>
                    <input class="form-control form-control-lg" v-model="token" type="text" placeholder="Digite seu token aqui">
                    <button class="btn btn-lg btn-primary btn-block" @click.prevent="AssinarCCB()">Assinar</button>
                </form>
                <!-- ínicio mensagem confirmação -->
                <div class="box-confirm" v-if="passo == 2">
                    <img src="/static/assets/images/icon-success.svg" alt="icone ok">
                    <h5>Sua CCB foi assinada com sucesso!</h5>
                    <!-- <p>As CCB’s foram assinadas com sucesso!</p> -->
                </div>
                <!-- final mensagem confirmação -->
            </div>
        </aside>
    </div>
</template>

<script>
/* eslint-disable */
    import ApiClient from '../utils/api-client'
    import HubClient from '../utils/hub-consulta-client'
    
	import * as mutationTypes from '@/store/mutation-types.js'
    export default {

        data(){
            return {
                CCB_URL:process.env.CCB_URL,
                passo:1,
                lista:[],
                token : '',
                reservas: {},
            }
        },

        methods:{
            AssinarCCB(){

                  ApiClient.get_GO(`out/verificarTokenParaEmailConfirmacao/${this.$route.params.id}/${this.token}`)
                    .then(token => {
                        console.log(token)
                        if(token.data == "ok"){
                            this.passo = 2;
                        }else{
                              this.$Notify.error("Erro: Token inválido!")
                        }

                     }).catch((ex) => {
                        
                         this.$Notify.error("Erro: Token inválido!")
                        });  

            },
            getClientAddress() {
                    HubClient.getIP().then(ip => {
                    this.IP = ip;

                    console.log(this.IP)
                })
                        
            },

            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/cadastrar-senha',
                    title: 'CadastrarSenha',
                })
            },

        },
        
        async created() {

            	if(window.location.href.indexOf("dashboard-app") != -1)

                  this.$store.commit(mutationTypes.START_LOADING)

                  this.getClientAddress();

                  ApiClient.get_GO(`out/solicitacaoTokenCCB/${this.$route.params.id}`)
                    .then(sol => {
                        sol = sol.data;

                        ApiClient.get_GO(`out/reservasInvestimentoSolicitacao/${sol._id}`)
                        .then(reserva => {
                            this.reservas = reserva.data;
                        }).catch((ex) => {
                            console.log("erro  ",ex)
                        });

                        var tokenEmail ="";
                        if(sol != null && sol != undefined && sol.Empresa != null)
                        {
                            if(sol.Empresa.Socios != null && sol.Empresa.Socios != undefined){
                                for(var i = 0 ; i < sol.Empresa.Socios.length ; i ++)    
                                {
                                    if(sol.Empresa.Socios[i].Token == this.$route.params.id )
                                    {
                                        if(sol.Empresa.Socios[i].Assinou == true)
                                        {
                                            this.passo = 2;
                                        }
                                        tokenEmail = sol.Empresa.Socios[i].TokenEmail;
                                        break;
                                    }
                                }
                            }

                            if(sol.Empresa.Avalistas != null && sol.Empresa.Avalistas != undefined && this.passo  == 1){
                                for(var i = 0 ; i < sol.Empresa.Avalistas.length ; i ++)    
                                {
                                    if(sol.Empresa.Avalistas[i].Token == this.$route.params.id )
                                    {
                                        if(sol.Empresa.Avalistas[i].Assinou == true)
                                        {
                                            this.passo = 2;
                                        }
                                        tokenEmail = sol.Empresa.Avalistas[i].TokenEmail;
                                        break;
                                    }
                                }
                            }
                        } 

                        if(this.passo == 1 && tokenEmail == ""){  

                            //Enviar Email para o cliente
                             ApiClient.get_GO(`out/criarTokenParaEmailConfirmacao/${this.$route.params.id}`)
                             .then(sol => {
                                this.$store.commit(mutationTypes.STOP_LOADING)
                             })
                             .catch((ex) => {
                                console.log("erro ",ex)
                                this.$store.commit(mutationTypes.STOP_LOADING)
                            }); 

                            this.$store.commit(mutationTypes.STOP_LOADING)
                        }
                        else{
                            this.$store.commit(mutationTypes.STOP_LOADING)
                        }
                         

                        }).catch((ex) => {
                         console.log("erro ",ex)
                         this.$store.commit(mutationTypes.STOP_LOADING)
                        });   

                    //tagueamento GA
                    await this.taggingGA()
                }
        
    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    img {
        width: 70px;
    }

    h1 {
        @include font-size(30px);
        @include line-height(30px);
        @include separador(160px, 5px, 25px, 25px, auto, auto, $c3);
    }
       
    h2 {
        @include font-size(20px);
        @include line-height(20px);
        @include separador(100%, 1px, 15px, 0px, auto, auto, #ddd);
    }
    p {
        @include font-size(20px);
        @include line-height(20px);
        color: #888;
    }

    @include xs {
        .icon-assinatura {
            width: 50px;
            margin-top: 100px;
        }
        h1 {
            @include font-size(20px);
            @include line-height(20px);
            @include separador(110px, 4px, 20px, 15px, auto, auto, $c3);
        }
        p {
            @include font-size(16px);
            @include line-height(16px);
        }
    }
    .ccbs {
        aside {
            .box {
                span {
                    @include font-size(14px);
                    @include line-height(14px);
                    font-weight: normal;
                    letter-spacing: 0;
                    color: #888;
                    display:block;
                    padding-bottom: 20px;
                }
            }
            h5 {
                @include font-size(17px);
                @include line-height(17px);
                @include separador(60%, 4px, 15px, 15px, auto, auto, $c3);
            }
            form {
                margin-top: 0px;
                .btn-link {
                    margin-bottom: 0px;
                }
            }
        }
    }

    .table {
        .btn {
            @include font-size(12px);
            text-transform: inherit!important;
        }
        tbody {
            th {
                @include font-size(13px);
                text-align: center;
            }
            th, td {
                padding:0px;
            }
            tr {
                &:first-child {
                    th, td {
                       border-top: none!important;
                    }
                }
                th {
                    &:nth-child(1) {
                        width: 6%;
                        color: #000;
                    }
                }
                td {
                    &:nth-child(3) {
                        width: 20%;
                        text-align: right;
                    }
                }
            }

            @include xs {
                tr {
                    th {
                        &:nth-child(1) {
                            width: 12%;
                        }
                    }
                    td {
                        &:nth-child(2) {
                           span {
                               small {
                                   display: none;
                               }
                           }
                        }
                        &:nth-child(3) {
                            width: 40%;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/CCBResponse.vue